export default class LanguageActions {
  static CHANGE = "CHANGE";
  static LOADED = "LOADED";
  static ISOPEN = "ISOPEN";
  static IS_OPEN_PROFILE = "IS_OPEN_PROFILE";
}
